import React from 'react';
import styles from './BrandFilter.module.css';

// Generic store labels that belong in "Others / Unbranded"
const GENERIC_BRANDS = new Set([
  'unknown', 'generic', 'unbranded', 'no brand', 'n/a',
  'amazon basics', 'amazonbasics',
  'onn.', 'onn',
  'mainstays',
  'threshold',
  'room essentials',
  'good & gather',
  'up&up', 'up & up',
  'hart',
  'hyper tough',
  'equate',
  'simply balanced',
  'market pantry',
  'open nature',
  'kirkland', 'kirkland signature',
  'members mark', "member's mark",
  'great value',
  'walmart',
]);

export function isGeneric(brand) {
  if (!brand) return true;
  return GENERIC_BRANDS.has(brand.toLowerCase().trim());
}

// Extract named brands + count Others
export function extractBrands(ranked) {
  const counts  = {};
  let otherCount = 0;

  ranked.forEach(r => {
    if (isGeneric(r.brand)) {
      otherCount++;
    } else {
      counts[r.brand] = (counts[r.brand] || 0) + 1;
    }
  });

  const brands = Object.entries(counts)
    .sort((a, b) => b[1] - a[1])
    .map(([brand, count]) => ({ brand, count }));

  if (otherCount > 0) {
    brands.push({ brand: '__others__', label: 'Others / Unbranded', count: otherCount });
  }

  return brands;
}

export default function BrandFilter({ brands, selected, onChange }) {
  if (!brands || brands.length < 2) return null;

  const toggleBrand = (brand) => {
    if (selected.includes(brand)) {
      onChange(selected.filter(b => b !== brand));
    } else {
      onChange([...selected, brand]);
    }
  };

  const clearAll = () => onChange([]);
  const isAll    = selected.length === 0;

  return (
    <div className={styles.wrap}>
      <span className={styles.label}>Brand:</span>
      <div className={styles.pills}>

        <button
          className={`${styles.pill} ${isAll ? styles.pillActive : ''}`}
          onClick={clearAll}
        >
          All
        </button>

        {brands.map(({ brand, label, count }) => {
          const active    = selected.includes(brand);
          const isOthers  = brand === '__others__';
          return (
            <button
              key={brand}
              className={`${styles.pill} ${active ? styles.pillActive : ''} ${isOthers ? styles.pillOthers : ''}`}
              onClick={() => toggleBrand(brand)}
            >
              {label || brand}
              <span className={active ? styles.countActive : styles.count}>
                {count}
              </span>
            </button>
          );
        })}

        {!isAll && (
          <button className={styles.clearBtn} onClick={clearAll}>
            Clear ×
          </button>
        )}
      </div>
    </div>
  );
}
